import { useEffect, useState } from "react"
import { ICompositeWidgetProps } from "../../LandingCompositeWidget"


const CanvasDisable = (props: ICompositeWidgetProps): JSX.Element => { 
    const [value, setValue] = useState<any>( props.value || [] ) 
    useEffect(() => {
        setValue( props.value || [] )
    }, [props.value])

    return <div className="d-flex flex-wrap">
        CanvasDisable
    </div>
}

export default CanvasDisable